import { HttpStatusCode } from "axios";

import { LocalKeyType, getLocalValue } from "../../libs/localStorage";
import { reissueToken } from "../../libs/request";

export default function useLongTermLogin() {
  const longTermLogin = async (
    text: LocalKeyType = "AUTO",
    onSuccess?: () => void
  ) => {
    try {
      const jwtToken = getLocalValue(text);
      if (jwtToken) {
        const res = await reissueToken({ refreshToken: jwtToken });
        if (res.status === HttpStatusCode.Ok) {
          onSuccess?.();
        } else {
          throw new Error("토큰 재발급 실패");
        }
      }
    } catch (e: any) {
      throw new Error(e);
    }
  };

  return longTermLogin;
}
